/**
 * Light2Live is invite-only (#331): coaches invite clients from admin and the
 * client sets a password through the activation link. Public sign-up returns
 * with payments and tiers. Until then the sign-up UI stays hidden unless the
 * build sets VITE_ALLOW_SELF_REGISTRATION=true, which only makes sense when the
 * backend's ALLOW_SELF_REGISTRATION is "true" as well.
 */
export function isSelfRegistrationEnabled(): boolean {
    return import.meta.env.VITE_ALLOW_SELF_REGISTRATION === 'true';
}
